export const FailedIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="#787878"
        d="M8 16c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8zM8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.2-7-7-7z"
      ></path>
      <path
        fill="#787878"
        d="M8.5 3.9h-1v5.7h1V3.9zM8.5 10.9h-1v1.4h1v-1.4z"
      ></path>
    </svg>
  );
};
